/*
 * Sheeply buy box: gallery thumbnails, variant pills and quantity
 * cards. Keeps the hidden id/quantity inputs and the prices in sync;
 * the add to cart itself is handled by gr-cart.js.
 */
if (!customElements.get('gr-buybox')) {
  customElements.define(
    'gr-buybox',
    class GrBuybox extends HTMLElement {
      connectedCallback() {
        this.threshold = parseInt(this.dataset.threshold, 10) || 0;
        this.moneyFormat = this.dataset.moneyFormat || '€{{amount}}';
        this.variantInput = this.querySelector('[data-variant-input]');
        this.qtyInput = this.querySelector('[data-qty-input]');
        this.ctaButton = this.querySelector('[data-cta-button]');
        this.ctaPrice = this.querySelector('[data-cta-price]');

        const checkedVariant = this.querySelector('input[name^="gr-variant-"]:checked');
        this.price = checkedVariant ? parseInt(checkedVariant.dataset.price, 10) : null;

        this.addEventListener('click', (event) => {
          const thumb = event.target.closest('[data-thumb]');
          if (thumb) this.showSlide(thumb.dataset.thumb);
        });

        this.addEventListener('change', (event) => {
          const input = event.target;
          if (input.name && input.name.startsWith('gr-variant-')) {
            this.variantInput.value = input.value;
            this.price = parseInt(input.dataset.price, 10);
            if (this.ctaButton) {
              const available = input.dataset.available === 'true';
              this.ctaButton.disabled = !available;
            }
            this.refresh();
          }
          if (input.name && input.name.startsWith('gr-tier-')) {
            this.qtyInput.value = input.value;
            this.refresh();
          }
        });

        this.refresh();
      }

      showSlide(index) {
        this.querySelectorAll('[data-slide]').forEach((slide) => {
          slide.classList.toggle('is-active', slide.dataset.slide === index);
        });
        this.querySelectorAll('[data-thumb]').forEach((thumb) => {
          const active = thumb.dataset.thumb === index;
          thumb.classList.toggle('is-active', active);
          if (active) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
      }

      refresh() {
        // Prices are rendered server-side; only recompute when a variant
        // with its own price has been picked.
        const qty = parseInt(this.qtyInput.value, 10) || 1;
        if (this.price === null) {
          const checkedTier = this.querySelector('input[name^="gr-tier-"]:checked');
          const total = checkedTier && checkedTier.closest('label').querySelector('[data-tier-total]');
          if (total && this.ctaPrice) this.ctaPrice.textContent = total.textContent;
          return;
        }

        this.querySelectorAll('input[name^="gr-tier-"]').forEach((input) => {
          const label = input.closest('label');
          const tierQty = parseInt(input.value, 10) || 1;
          const total = this.price * tierQty;
          const free = this.threshold > 0 && total >= this.threshold;
          const totalEl = label.querySelector('[data-tier-total]');
          const unitEl = label.querySelector('[data-tier-unit]');
          const tagEl = label.querySelector('[data-tier-tag]');
          const noteEl = label.querySelector('[data-tier-note]');
          if (totalEl) totalEl.textContent = this.formatMoney(total);
          if (unitEl) unitEl.textContent = this.formatMoney(this.price);
          if (tagEl) tagEl.hidden = !free;
          if (noteEl) noteEl.textContent = free ? noteEl.dataset.freeText : noteEl.dataset.paidText;
        });

        if (this.ctaPrice) this.ctaPrice.textContent = this.formatMoney(this.price * qty);
      }

      formatMoney(cents) {
        const format = (value, decimals, thousands = ',', decimal = '.') => {
          const fixed = (value / 100).toFixed(decimals);
          const [whole, fraction] = fixed.split('.');
          const withThousands = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          return fraction && fraction !== '00' ? withThousands + decimal + fraction : withThousands;
        };
        return this.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => {
          switch (key) {
            case 'amount_no_decimals':
              return format(cents, 0);
            case 'amount_with_comma_separator':
              return format(cents, 2, '.', ',');
            case 'amount_no_decimals_with_comma_separator':
              return format(cents, 0, '.', ',');
            case 'amount_with_apostrophe_separator':
              return format(cents, 2, "'", '.');
            case 'amount_with_space_separator':
              return format(cents, 2, ' ', ',');
            default:
              return format(cents, 2);
          }
        });
      }
    }
  );
}
